
import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { LucideIcon, Form, Row, Col, Label, Checkbox, Input, Radio, Select, generateShadesFromHex, useCRUDController, useGlobalTempStore, getValueByCode } from './ot';
import { Card } from './card';
const colors = ['#1eae53', '#0950c3', '#7000cc', '#c2690a', '#bc1010', '#7000cc', '#36cfc9', '#ff4d4f', '#ffc53d', '#40a9ff', '#73d13d', '#9254de', '#ff7a45'];
const defaultData = []
const Base5wCard = ({
    cardsPerRow = 5, // 預設每行5個
    propsFiveWData, // 5w 資料
    fivewApi = '/process_management/backend/process_5w',
    dbCoverIdName = 'process_document_id',
    propsDbCoverId, // 目前文件的 id
    dataCount = 0,
    onFormFinish = () => { },
    onChange = () => { },
    fiveWResponseData = [],
    allDocumentData = [],
    readOnly = false
}) => {
    const [form] = Form.useForm();

    const [fiveWData, setFiveWData] = useState([]);
    const prevPropsFiveWKeyRef = useRef(null);

    const fiveWController = useCRUDController({
        apiRoute: fivewApi,
        onBefore: ({ axiosMode, status }) => {

        },
        onFinish: ({ axiosMode, status, values }) => {
            // Handle finish logic
        }
    });
    const getFiveWData = () => {
        if (propsFiveWData) {
            form.resetFields({ five_w_data: propsFiveWData })
            // setFiveWData(propsFiveWData);
        } else {
            if (!!fivewApi) {
                fiveWController.getData({
                    [dbCoverIdName]: propsDbCoverId
                }).then((response) => {
                    let data = response?.data || [];
                    if (data && data.length > 0) {
                        setFiveWData(data);
                    } else {
                        setFiveWData([]);
                    }
                })
                    .catch((error) => {
                        setFiveWData([]);
                    });
            }

        }

    }

    useEffect(() => {
        // Only fetch when content actually changed.
        // propsFiveWData is an array of objects, so shallow reference changes may occur
        // even when content is the same. We serialize to JSON and compare to previous
        // serialized value to detect real changes.
        try {
            const key = JSON.stringify(propsFiveWData ?? []);
            const prevKey = prevPropsFiveWKeyRef.current;
            // If fivewApi changed, always run getFiveWData (so include fivewApi change)
            const fivewApiChanged = prevPropsFiveWKeyRef.current?._api !== fivewApi;
            if (fivewApiChanged) {
                // store both api and serialized data
                prevPropsFiveWKeyRef.current = { _api: fivewApi, _key: key };
                getFiveWData();
                return;
            }

            if (!prevKey || key !== prevKey._key) {
                prevPropsFiveWKeyRef.current = { _api: fivewApi, _key: key };
                // only call when content changed (or first time)
                getFiveWData();
            } else {
                // no-op: content identical, do nothing
            }
        } catch (e) {
            // Fallback: if stringify fails for some reason, just fetch
            getFiveWData();
        }
    }, [propsFiveWData, fivewApi]);

    useEffect(() => {
        form.submit()
    }, [dataCount]);
    return (
        <div>
            <Base5wForm
                propsForm={form}
                cardsPerRow={cardsPerRow}
                onFormFinish={onFormFinish}
                onChange={onChange}
                fiveWResponseData={fiveWResponseData}
                allDocumentData={allDocumentData}
                readOnly={readOnly}
            />

        </div>
    );
};
const Base5wForm = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {},
    formColumnApi = '/utility/form/newest',
    formColumnApiParams,
    cardsPerRow = 1,
    onChange = () => { },
    fiveWResponseData = [],
    allDocumentData = [],
    readOnly = false
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_;
    const [count, setCount] = useState(0)
    const [showElseSettingMap, setShowElseSettingMap] = useState({});

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {
        if (readOnly) return; // 唯讀模式不觸發變更
        let formValues = null;
        formValues = form.getFieldsValue();
        // 取得最新表單值
        // const map = {};
        // (value?.five_w_data || []).forEach((fivew, i) => {
        //     (fivew?.form_column_data || []).forEach((col, j) => {
        //         if (col?.code === "處理步驟節點數") {
        //             const selectedOptionId = col?.value?.value;
        //             const option = (col?.form_column_selection_option_data || []).find(opt => opt?.selection_option_id === selectedOptionId);
        //             const label = option?.selection_option_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value;
        //             // 自動寫入 else_setting
        //             if (label && /^\d+個步驟$/.test(label)) {
        //                 // 取數字
        //                 const stepNum = parseInt(label, 10);
        //                 // 設定 else_setting
        //                 form.setFieldValue(['five_w_data', i, 'form_column_data', j, 'else_setting'].join('.'), stepNum);
        //                 map[`${i}-${j}`] = false; // 不顯示自訂欄
        //             } else if (label === "自訂步驟") {
        //                 map[`${i}-${j}`] = true; // 顯示自訂欄
        //                 // 清空 else_setting
        //                 form.setFieldValue(['five_w_data', i, 'form_column_data', j, 'else_setting'].join('.'), undefined);
        //             } else {
        //                 map[`${i}-${j}`] = false;
        //                 form.setFieldValue(['five_w_data', i, 'form_column_data', j, 'else_setting'].join('.'), undefined);
        //             }
        //         }
        //     });
        // });
        // setShowElseSettingMap(map);
        formValues = form.getFieldsValue();

        onChange(formValues)
    };

    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);
    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                    disabled={readOnly}

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                formColumnApi={formColumnApi}
                                field={field}
                                form={form}
                                formColumnApiParams={formColumnApiParams}
                                cardsPerRow={cardsPerRow}
                                count={count}
                                showElseSettingMap={showElseSettingMap}
                                fiveWResponseData={fiveWResponseData}
                                allDocumentData={allDocumentData}
                                readOnly={readOnly}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    form,
    formColumnApi = "/utility/form/newest",
    formColumnApiParams,
    cardsPerRow = 5,
    showElseSettingMap,
    count,
    fiveWResponseData = [],
    allDocumentData = [],
    readOnly = false
}) => {
    // const formColumnController = useCRUDController({ apiRoute: formColumnApi })
    // const [formFormColumnData, setFormFormColumnData] = useState([])
    // const [document_id, setDocumentId] = useState([])
    const { tempData, setItem, getItem, removeItem, clear, getOrFetchItem, version } = useGlobalTempStore();
    const FiveWNameSetting = {
        2: ["參與單位", "通知對象"],    //人
        3: ["處理事項類型"],           //事
        4: [],                       //時
        5: ["地點類型", '主要處理地點'],              //地
        6: []            //物
    }
    const getFiveWResponseDataByFormColumnName = (name) => {
        let formColumnFiveWId = Object.keys(FiveWNameSetting).find((key) => {
            return FiveWNameSetting[key].includes(name)
        })

        if (!formColumnFiveWId) {
            return []
        }
        let responseData = fiveWResponseData.find(ele => ele?.five_w_id === parseInt(formColumnFiveWId))?.response_data || []
        let options = responseData.map((responseValue) => {
            let finalCode = "名稱"
            let response_form_value_data = responseValue?.response_form_value_data || []
            response_form_value_data.forEach((value_item) => {
                let form_column_form_value_data = value_item?.form_column_form_value_data || []
                form_column_form_value_data.forEach((form_column_value_item) => {
                    let code = form_column_value_item?.code
                    let value = value_item?.value?.value
                    if (code.includes("名稱")) {
                        finalCode = code
                    }
                })
            })
            let value = getValueByCode({ response_form_value_data: responseValue?.response_form_value_data, code: finalCode })
            return {
                label: (value || "無名稱")  ,
                value: responseValue?.response_id
            }
        })

        return options || []
    }
    const renderSettingComponent = ({ type, setting, readOnly }) => {

        // 動態選單選項 (response)
        let dynamic_selection_option_data = []
        // 動態選單選項 (document)
        let document_selection_option_data = allDocumentData.map((doc) => {
            return {
                label: doc?.document_name,
                value: doc?.document_id
            }
        })

        // 新-動態選單選項（吃 form_column_source_data）
        let form_column_source_data = setting?.form_column_source_data || []
        form_column_source_data?.forEach((source) => {
            source?.document_source_data?.forEach((doc) => {
                if (!getItem(doc?.document_id)?.response_data) {
                    getOrFetchItem(doc?.document_id)
                }
                let response_data = getItem(doc?.document_id)?.response_data || []
                if (response_data && response_data.length > 0) {
                    response_data.forEach((response_item) => {
                        let response_id = response_item?.response_id
                        let response_form_value_data = response_item?.response_form_value_data || []
                        response_form_value_data.forEach((value_item) => {
                            let form_column_form_value_data = value_item?.form_column_form_value_data || []
                            let form_column_form_value_data_first = form_column_form_value_data.find(_ => true)
                            let code = form_column_form_value_data_first?.code
                            if (code === "名稱") {
                                dynamic_selection_option_data.push({
                                    label: value_item?.value?.value,
                                    value: response_id
                                })
                            }
                        })
                    })
                }
            })
        })
        // 新-動態選單選項（吃每個節點的 form_column_data）
        let form_column_data = setting?.form_column_data || []
        form_column_data?.forEach((column) => {
            column?.form_column_source_data?.forEach((source) => {
                source?.document_source_data?.forEach((doc) => {
                    if (!getItem(doc?.document_id)?.response_data) {
                        getOrFetchItem(doc?.document_id)
                    }
                    let response_data = getItem(doc?.document_id)?.response_data || []
                    if (response_data && response_data.length > 0) {
                        response_data.forEach((response_item) => {
                            let response_id = response_item?.response_id
                            let response_form_value_data = response_item?.response_form_value_data || []
                            response_form_value_data.forEach((value_item) => {
                                let form_column_form_value_data = value_item?.form_column_form_value_data || []
                                let form_column_form_value_data_first = form_column_form_value_data.find(_ => true)
                                let code = form_column_form_value_data_first?.code
                                if (code === "名稱") {
                                    dynamic_selection_option_data.push({
                                        label: value_item?.value?.value,
                                        value: response_id
                                    })
                                }
                            })
                        })
                    }
                })
            })
        })
        // 靜態選單選項
        let static_selection_option_data = []
        let form_column_selection_option_data = setting?.form_column_selection_option_data || []
        form_column_selection_option_data.forEach((item) => {
            let selection_option_classify_structure_type_data = item?.selection_option_classify_structure_type_data || []
            let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data.find(_ => true)
            let name_language_data = selection_option_classify_structure_type_data_first?.name_language_data || []
            let name_language_data_tw = name_language_data.find(_ => _.language_culture_code === "zh-tw")?.language_culture_value
            static_selection_option_data.push({
                label: name_language_data_tw,
                value: item?.selection_option_id
            })
        })
        // 合併選單選項 暫定所有靜動態資料
        let all_selection_option_data = [...dynamic_selection_option_data, ...static_selection_option_data]
        // 所有documnent 的 document_data (用於必要表單文件)

        // 特定 five_w_id 的 response_data
        let formColumnFiveWId = Object.keys(FiveWNameSetting).find((key) => {
            return FiveWNameSetting[key].includes(setting?.code)
        })
        let specificFiveWResponseData = []
        if (!!formColumnFiveWId) {
            specificFiveWResponseData = getFiveWResponseDataByFormColumnName(setting?.code)
        }
        // 最終決定使用哪個選單選項
        if (setting?.code === "必要表單文件") {
            all_selection_option_data = document_selection_option_data
        }
        else if (!!formColumnFiveWId) {
            all_selection_option_data = specificFiveWResponseData
        }

        if (type === "datetime") {
            return (
                <Input key={setting?.subfield?.name} type="datetime-local" placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            );
        }
        else if (type === 'text-content') {
            return (
                <Input key={setting?.subfield?.name} placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            );
        }
        else if (type === "number_input") {
            return (
                <Input key={setting?.subfield?.name} type="number" placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            )
        }
        else if (type === "dropdown") {
            /**
             * process-006 4.
             * 4.code對應欄位呈現下拉式選單
             */
            return (
                <Select
                    key={setting?.subfield?.name}
                    allowClear={setting?.code === "必要表單文件" ? false : true}
                    placeholder={setting?.placeholder}
                    options={all_selection_option_data}
                    disabled={readOnly}
                />
            )
        }
        else if (type === "checkbox") {
            const groupOptions = (all_selection_option_data || []).map(opt => ({ ...opt, disabled: readOnly }));
            return (
                <Checkbox.Group name={setting?.name} options={groupOptions} />
            )
        }
        else if (type === "radio_button") {
            return (
                <Radio.Group>
                    {all_selection_option_data.map((option) => (
                        <Radio key={option.value} value={option?.value} disabled={readOnly}>
                            {option?.label}
                        </Radio>
                    ))}
                </Radio.Group>
            )
        }
        else if (type === "datetime_picker") {
            return (
                <Input type="date" placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            )
        }
        else if (type === "multi_select_list") {
            return (
                <Select
                    allowClear={setting?.code === "必要表單文件" ? false : true}
                    placeholder={setting?.placeholder}
                    mode="multiple"
                    options={all_selection_option_data}
                    disabled={readOnly}
                />
            )
        }
        else if (type === "textarea") {
            return (
                <Input.TextArea placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            )
        }
        else if (type === "email_input") {
            return (
                <Input type="email" placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            )
        }
        else if (type === "phone_input") {
            return (
                <Input type="tel" placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            )
        }
        else if (type === "url_input") {
            return (
                <Input type="url" placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            )
        }
        else if (type === "password_input") {
            return (
                <Input type="password" placeholder={setting?.placeholder} disabled={readOnly} readOnly={readOnly} />
            )
        }

    };
    useEffect(() => {

    }, [])
    return (
        <Row>
            <Col span={24}>
                <Form.List
                    {...field}
                    name={[field?.name, 'five_w_data']}>
                    {(fields, { add, remove }) => <div
                        className="gap-4"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${cardsPerRow}, minmax(0, 1fr))`,
                        }}>
                        {fields.map((field, i) => < >
                            <Row  >
                                <Col span={24}>
                                    <ColorCard key={i}
                                        {...field}
                                        color={colors[i % colors.length]}>
                                        <Row gutter={[4, 4]}>
                                            <Col span={24}>
                                                {
                                                    <Form.List
                                                        {...field}
                                                        name={[field?.name, 'form_column_data']}>
                                                        {(subfields, { add, remove }) => <>
                                                            {subfields.map((subfield, j) => {
                                                                let component_definition_data = subfield?.form_column_component_definitions_data;
                                                                let component_definition_data_first = component_definition_data?.find(_ => true) || {};
                                                                let type = component_definition_data_first?.component_type;
                                                                let code = subfield?.code;
                                                                // 判斷是否顯示 else_setting
                                                                // const showElse = code === "處理步驟節點數" && showElseSettingMap[`${i}-${j}`];
                                                                return <>
                                                                    <Row  >
                                                                        <Form.Item
                                                                            labelCol={24}
                                                                            wrapperCol={24}
                                                                            label="form_form_column_id"
                                                                            name={[subfield?.name ?? '', 'form_column_id']}
                                                                            hidden={true}
                                                                        >
                                                                            <Input />
                                                                        </Form.Item>
                                                                        <Form.Item
                                                                            labelCol={24}
                                                                            wrapperCol={24}
                                                                            label="form_column_id"
                                                                            name={[subfield?.name ?? '', 'form_column_id']}
                                                                            hidden={true}
                                                                        >
                                                                            <Input />
                                                                        </Form.Item>
                                                                        <Col span={24}>
                                                                            <Form.Item
                                                                                labelCol={24}
                                                                                wrapperCol={24}
                                                                                label={subfield?.code}
                                                                                name={[subfield?.name ?? '', 'value.value']}
                                                                                disabled={readOnly}
                                                                            >
                                                                                {renderSettingComponent({ type, setting: subfield, fiveWResponseData, readOnly })}
                                                                            </Form.Item>
                                                                        </Col>
                                                                        {/* {showElse && (
                                                                            <Col span={24}>
                                                                                <Form.Item
                                                                                    labelCol={24}
                                                                                    wrapperCol={24}
                                                                                    label="自訂步驟數"
                                                                                    name={[subfield?.name ?? '', 'else_setting']}
                                                                                    rules={[{ required: true, message: '請輸入步驟數' }]}
                                                                                >
                                                                                    <Input type="number" placeholder="請輸入步驟數" />
                                                                                </Form.Item>
                                                                            </Col>
                                                                        )} */}

                                                                    </Row>
                                                                </>
                                                            })}
                                                        </>}
                                                    </Form.List>
                                                }
                                            </Col>
                                        </Row>
                                    </ColorCard>

                                </Col>
                            </Row >
                        </>)}
                    </div>}
                </Form.List>
            </Col>
        </Row >
    );
};
const ColorCard = ({ title, color = '#ad46ff', children, icon }) => {
    return (
        <Card className=" flex-shrink-0 p-4 border-l-4 "
            style={{ borderLeftColor: generateShadesFromHex(color)?.["600"] }}
        >
            <div className="flex items-center gap-2 mb-3">
                <span className="text-lg"><LucideIcon color={generateShadesFromHex(color)?.["600"]} name={icon ?? "Circle"} /></span>
                <h3 className="font-medium "
                    style={{ color: generateShadesFromHex(color)?.["600"] }}
                >{title}</h3>
            </div>
            <div className="space-y-3">
                {children}
            </div>
        </Card>
    );
}
export default Base5wCard;
